
import { Component, EventEmitter, HostListener, Inject, Injectable, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CellFocusedEvent, ColDef, Column, ColumnApi, ColumnResizedEvent, GridApi, GridOptions, GridReadyEvent, ILoadingOverlayParams, RowClassParams, RowDoubleClickedEvent, RowSelectedEvent, SortChangedEvent } from '@ag-grid-community/core';
import { HTTPService } from 'src/app/services/http.service';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import moment from 'moment';
import { DialogService } from 'src/app/services/dialog.service';
import { PromptFilterViewComponent } from '../prompt-filter-view/prompt-filter-view.component.js';
import { FilterParam } from 'src/app/interfaces/filter-param.js';
import * as XLSX from 'xlsx';
import { UserConfigServices } from 'src/app/services/user-config.services.js';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services.js';
import { ILoadingOverlayAngularComp } from '@ag-grid-community/angular';
import { QueryConnSettings, QueryExcutorSettings, QueryExecutorComponentSettings } from './query-executor-settings/query-executor-settings.component.js';
import { max, Subscription } from 'rxjs';
import { ThemeService } from 'src/app/services/theme.service';
import { ExcelUtils } from 'src/app/system-utils/utils/ExcelUtils.js';
import { SnackbarService } from 'src/app/services/snackbar.service.js';
import { Editor } from 'ngx-editor';

import { Pipe, PipeTransform } from '@angular/core';
import { LanguageServices } from 'src/app/services/LanguageServices';

@Pipe({
    name: 'filterPipe',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: string[], filterText: string): string[] {
    if (!items || !filterText) {
      return items;
    }
    return items.filter(item => item.toLowerCase().includes(filterText.toLowerCase()));
  }
}



@Injectable({
  providedIn: 'root',
})

export class QueryServices {

  dialogService:DialogService =  inject(DialogService);
  
  sub3: Subscription;
  constructor(private http:HTTPService){}

  applyFilters(query: string ) {

    return new Promise((resolve,reject)=>{
      
        let newQuery = query;
      
        let reg: RegExpMatchArray = query.match(/{@(.*?)}/g);
        if (reg != null) {

          let dataFilters:FilterParam[] = [];

          reg.forEach(d=>{
              let fieldName = d.replace("{@", "").replace("}", "").trim();
              let params:String[] = fieldName.split(';');
              let filterParam:FilterParam = {
                  nome: fieldName,
                  desc: fieldName,
                  tipo: 'S'
              }
              if ( params.length > 1){
                params.forEach(p=>{
                    let key:string = p.split('=')[0];
                    let name:string = p.split('=')[1];
                    filterParam[key] = name;
                });
              }
              dataFilters.push(filterParam);
          });
          
          let data = {
              data:JSON.parse(JSON.stringify(dataFilters)),
              title:'Parâmetros',
              useParamFilter: true
          };

          if ( dataFilters.length > 0 ){
            this.dialogService.openGenericDialog(PromptFilterViewComponent,data,(val)=>{
              
              let retorno = JSON.parse(val);
              let group = retorno.group;
              
              reg.forEach(d=>{
                let fieldName = d.replace("{@", "").replace("}", "").trim();

                if ( group != null ){
                  let value = group[fieldName];
                  
                  if ( value != null ){
                    if ( value instanceof moment){
                        let newData  = moment(value).format('yyyy-MM-dd HH:mm:ss.SSS'); 
                        newQuery = newQuery.replace(d,newData);
                    }else{
                      newQuery = newQuery.replace(d,group[fieldName]);
                    }
                  }
                }
              });
              resolve(newQuery);
            });
          }else{
            resolve(newQuery);
          }
        }else{
          resolve(newQuery);
        }
    });
    
  }

  ngOnDestroy(): void {
      if ( this.sub3 != null ){ this.sub3.unsubscribe(); }
  }

  async findNative(query:string, testMode:boolean, maxRows:number, type:string = 'sqlserver' ){
      
      return await new Promise((resolve, reject) => {
    
          if ( query== null || query==""){
            resolve(true);
            return;
          }
      
          this.applyFilters(query).then(newQuery=>{

            let queryBuscaAcoes = {
              entityName: "Mktpdic",
              sql: newQuery,
              testMode: testMode,
              maxRows: maxRows,
              type: type
            };
  
            this.sub3 = this.http
            .post(
              queryBuscaAcoes,
              "JsonBrokerServices/findnative",
              false,
              true,
              true
            )
            .subscribe((con) => {
                let resultSet = con["SQL"];
                resolve(resultSet);
              },
            error=>{
              reject(error);
            });
    
          });
      
        });
  }

}


type CustomLoadingOverlayParams = ILoadingOverlayParams & { loadingMessage: string };
@Component({
    template: `
        <div class="ag-overlay-loading-center" role="presentation">
            <div
                role="presentation"
                style="width: 80px; height: 80px; background: url('./assets/image/temapi.gif') center / contain no-repeat; margin: 0 auto;"
            ></div>
            <div aria-live="polite" aria-atomic="true">{{ params.loadingMessage|translate }}</div>
        </div>
    `,
    standalone: false
})
export class CustomLoadingOverlay implements ILoadingOverlayAngularComp {
    public params!: CustomLoadingOverlayParams;

    agInit(params: CustomLoadingOverlayParams): void {
        this.refresh(params);
    }

    refresh(params: CustomLoadingOverlayParams): void {
        this.params = params;
    }
}



@Component({
    selector: 'query-executor-popup-dialog',
    templateUrl: './query-executor-popup-dialog.component.html',
    styleUrls: ['./query-executor-popup-dialog.component.scss'],
    standalone: false
})
export class QueryExecutorPopupDialog {
  
  constructor(
    public dialogRef: MatDialogRef<QueryExecutorPopupDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    
  }

  checkSize(value){

    if (typeof value === 'string') {
      if ( value.length <=100 ){
        return true;
      }else{
        return false;
      }
    }
    return true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

export interface TabQuerySettings{
  btnName: string;
  type: any;
  icon: string;
  index:number;
  name:string;
  query?:string;
  leftDivVer?:number;
  rightDivVer?:number;
  rows?:any[];
  displayedColumns?:ColDef[];
  gridAPI?:GridApi;
  selectedRows?: any[];
  dataGridFocus?: boolean;
  columnSelected?: Column<any>|string;
  rowIndex?: number;
}

export interface ObjectDefinition{
  INSTANCENAME:string;
  INSTANCEDESC:string,
  TYPE:string
}

@Component({
    selector: 'query-executor',
    templateUrl: './query-executor.component.html',
    styleUrls: ['./query-executor.component.scss'],
    standalone: false
})
export class QueryExecutorComponent implements OnInit {

  @Input() query:string='';
  @Input() testMode:boolean = false;
  @Input() maxRows:number = 100;
  @Input() showObject:boolean = true;
  @Output() queryChange:EventEmitter<string> = new EventEmitter<string>();
  currentSortColumn:string;
  /** índice da aba de query ativa (substitui o ViewChild de MatTabGroup) */
  selectedTabIndex: number = 0;
  /** spinner NG-ZORRO (substitui o ngx-spinner 'query-executor') */
  queryLoading = false;
  objects:ObjectDefinition[] =[]
  editor: Editor;
  
  queryExecuted = false;
  @Input() usePopup = true;
  popup = false;
  buttonList:ButtonList[] = [];
  sankhyaConfig:Object[] = [];
  
  rowsTestMode:any[] = [];
  displayedColumnsTestMode:ColDef[] = [];
  
  useMongo: boolean = false;

  tabs:TabQuerySettings[] = [{
    index:0,
    name:"Query 1",
    query:"",
    leftDivVer:50,
    rightDivVer:50,
    rows:[],
    displayedColumns:[],
    gridAPI: null,
    icon:'temapi',
    type:null,
    btnName:null,
    columnSelected:null,
    dataGridFocus:false,
    rowIndex:-1,
    selectedRows:[]
    
  }];

  public gridOptions: GridOptions = {
    enableRangeSelection: true,
    onRowDoubleClicked:(event:RowDoubleClickedEvent)=>{
        this.openPopUp(event);
    },

    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
    }
  };

  leftDivHor = 50;
  rightDivHor = 50;
  leftDivVer = 50;
  rightDivVer = 50;
  canExport = false;
  useTab = false;
  public loading: boolean = false;
  public loadingOverlayComponent: any = CustomLoadingOverlay;
  public loadingOverlayComponentParams: any = {
    loadingMessage: "QUERY_EXECUTOR.AGGRID.LOADING",
  };
  showSankhya: boolean = false;
  config: QueryExcutorSettings;
  buttonAdd:QueryConnSettings[];
  sub1: Subscription;
  sub2: Subscription;
  showConnection: boolean = false;
  gridAPI: GridApi<any>;
  
  

  constructor(private http:HTTPService,@Inject(MAT_DIALOG_DATA) public data:any, public dialogRef:MatDialogRef<any>,
  private queryServices:QueryServices, private ucs:UserConfigServices, private us:UserAuthenticationServices,
  private dialogServices:DialogService,
  public ThemeService:ThemeService,
  public ls:LanguageServices,
  private snackBar:SnackbarService) {
      if ( this.us.user.profile == 'ADMIN'){
        this.canExport = true;
      }
   }
   
   getCurrentItem(){
      if ( this.selectedTabIndex > -1 ){
        return this.tabs[this.selectedTabIndex];
      }
   }

   getCurrentQuery(){
    if ( this.tabs[this.selectedTabIndex] == null ){
      return "";
    }
    return this.tabs[this.selectedTabIndex].query;

   }

   getCurrentRow(){

    if ( this.tabs[this.selectedTabIndex] == null ){
      return [];
    }
    return this.tabs[this.selectedTabIndex].rows;
   }

  openConfiguration(){
    this.dialogServices.openGenericDialog(QueryExecutorComponentSettings,this.config,
      (val)=>{
        
        let obj = val as QueryExcutorSettings;
        this.config = obj;
        this.maxRows = this.config['maxRows'];
        this.showConnection = this.config['showConnection'];
        this.saveUserConfig();


      },()=>{},"100vh",
      "80vw",
      true,
      null,
      'S',
      "0");
  }

  openPopUp(event:RowDoubleClickedEvent){
    this.dialogServices.openGenericDialog(QueryExecutorPopupDialog,event.data,(val)=>{});

  }

  ngOnDestroy(): void {
      if ( this.sub1 != null ){ this.sub1.unsubscribe(); }
      if ( this.sub2 != null ){ this.sub2.unsubscribe(); }
      if ( this.editor != null) { this.editor.destroy(); }
  }


  ngOnInit(): void {
    
    this.editor = new Editor({
      keyboardShortcuts: false,
    });

    this.queryLoading = true;
    this.sub1 = this.ucs.loadUserPreference(this.us.user.iduser,'query_executor').subscribe({
      next:(data)=>{
          let pref:Object[] = data['Mktpuserpref'];
          
          if ( ObjectUtil.isNotEmpty(pref) && pref.length > 0 ){
            let prefObject:Object = JSON.parse(pref[0]['PREFERENCE']);
            this.leftDivHor =  prefObject['leftDivHor'];
            this.rightDivHor =  prefObject['rightDivHor'];

            if ( prefObject['tabs'] != null ){
              this.tabs = JSON.parse(prefObject['tabs']);
              this.tabs.map((d:TabQuerySettings)=>{d.query == null? d.query = '' : d.query = d.query;});
            }

            if ( prefObject['config'] != null ){
              this.config = prefObject['config'];
              this.buttonAdd = this.config['ROWSFIELDS']!=null ? this.config['ROWSFIELDS'] : [];  
              this.canExport  = this.canExport ? this.canExport : this.config['canExport'];
              this.showConnection = this.config['showConnection'];
              if ( this.config['maxRows'] != null ){
                this.maxRows = this.config['maxRows'];
              }
            }
            
             
          }

          if ( ObjectUtil.isNotEmpty(this.data) && this.data != null && this.data.query ){
            
            this.query = this.data.query==null?'' : this.data.query;
            if ( !this.usePopup ){
              this.popup = false;
            }else{
              this.popup = true;
            }

            this.buttonList.push({
              color:"primary",
              description:"OK",
              action: (data)=>{
                  this.okFunction(data);
              }
            })  
    
            this.buttonList.push({
              color:"warn",
              description:"Cancelar",
              action: (data)=>{
                  this.close();
              }
            })  
          
          }
    
          if (this.showObject ){
            this.loadObjects().then((d:{INSTANCENAME:string,INSTANCEDESC:string,TYPE:string}[])=>{
                this.objects = d;
                ///todo
            }).finally(()=>{
                this.queryLoading = false;
            });
          }else{
            this.queryLoading = false;
          }
        }
    })
      
  }

  close(){
    this.dialogRef.close();
  }

  async loadObjects(){

    return await new Promise((resolve, reject) => {
    
      let q = `
      SELECT INSTANCENAME, INSTANCEDESC, 'TABLES' TYPE, 1 ACTIVE
      FROM MKTPDIC
      WHERE INSTANCENAME IN (SELECT NAME FROM SYS.OBJECTS WHERE TYPE='U')
      UNION ALL
      SELECT NAME,NULL, 'VIEW', 1 ACTIVE FROM SYS.OBJECTS WHERE TYPE='V'
      UNION ALL
      SELECT NAME,NULL, 'FUNCTIONS', 1 ACTIVE FROM SYS.OBJECTS WHERE TYPE='FN'
      UNION ALL
      SELECT NAME,NULL, 'PROCEDURE',1 ACTIVE FROM SYS.OBJECTS WHERE TYPE='P'
      UNION ALL
      SELECT NAME,NULL, 'TRIGGERS', CASE WHEN IS_DISABLED=1 THEN 0 ELSE 1 END FROM SYS.TRIGGERS WHERE TYPE='TR'
      ORDER BY 1`
  
      let queryBuscaAcoes = {
        entityName: "Mktpdic",
        sql: q
      };

      this.sub2 = this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
            let resultSet = con["SQL"];
            resolve(resultSet);
          });

      });
  }

  saveUserConfig(){
    let newTabs:TabQuerySettings[] = [];
    this.tabs.forEach(d=>{
      newTabs.push({  
          index:d.index,
          name:d.name,
          query:d.query,
          leftDivVer:d.leftDivVer,
          rightDivVer:d.rightDivVer,
          displayedColumns:null,
          gridAPI:null,
          rows:null,
          icon:d.icon,
          type:d.type,
          btnName:d.btnName,
          columnSelected:null,
          dataGridFocus:false,
          rowIndex:-1,
          selectedRows:[]
      });
    });

    try{
      let userConfig = {
          leftDivHor: this.leftDivHor,
          rightDivHor: this.rightDivHor,
          maxRows: this.maxRows,
          tabs: JSON.stringify(newTabs),
          config: this.config
      }
      
      this.ucs.saveUserResource('query_executor', this.us.user.iduser,userConfig);

    }catch(error){
      throw error;
    };
  }


  /** nzResizeEnd emite os tamanhos em PIXELS; a preferência é salva em percentual */
  onSplitResizeEnd(type:string, sizes:number[], item:TabQuerySettings){

    let total = sizes.reduce((a,b)=> a + b, 0);
    if ( total <= 0 ){
      return;
    }

    let pct = sizes.map(s=> (s / total) * 100);

    if ( type == 'horizontal'){
      this.leftDivHor = pct[0];
      this.rightDivHor = pct[1];
    }else{
      if ( this.testMode ){
        this.leftDivVer = pct[0];
        this.rightDivVer = pct[1];
      }else{
        item.leftDivVer = pct[0];
        item.rightDivVer = pct[1];
      }

    }

    if ( !this.testMode ){
      this.saveUserConfig();
    }

  }

  performActionTestMode(event:KeyboardEvent){
    
    if (event.ctrlKey && event.key === 'e') {

      event.preventDefault();
      
      this.executeQueryTestMode();
    }
    
  }

  performAction(event:KeyboardEvent, item:TabQuerySettings){
    
    if (event.ctrlKey && event.key === 'e') {

      event.preventDefault();
      
      if ( item.type == null ){
          throw new Error("Tipo de conexão. Execute a query manualmente.");
      }

      let btn = this.buttonAdd.filter(d=>d.NAME == item.btnName);
      
      if ( btn!= null && btn.length > 0 ){
        this.executeQuery(item,item.type, btn[0],item.icon);
      }else{
        this.executeQuery(item,item.type, null,item.icon);
      }
    }
    
  }
  
  async selectObject(item:ObjectDefinition){

    let index = this.tabs.findIndex(d=>d.name == item.INSTANCENAME);
    
    if ( index == -1 ){
      this.tabs.push(
        {
          index:this.tabs.length==0? 1 : Math.max(...this.tabs.map(d=>d.index))+1,
          name:item.INSTANCENAME,
          type:'sqlserver_desc_object',
          icon:'sqlserver',
          query:await this.getObjectDefinition(item) ,
          btnName:item.TYPE=='TABLES'? `${item.INSTANCENAME} (${item.INSTANCEDESC})` : item.INSTANCENAME,

        }
      );
      this.selectedTabIndex = this.tabs.length - 1;
      this.saveUserConfig();
    }else{
      this.selectedTabIndex = index;
    }
    
    
  }
  getObjectDefinition(item: ObjectDefinition): Promise<string> {
    return  new Promise((resolve, reject) => {
    
      let q = `SELECT DBO.GET_OBJECT_DEFINITION('${item.INSTANCENAME}','${item.TYPE}')  TEXTO FROM DUAL`
      let queryBuscaAcoes = {
        entityName: "Mktpdic",
        sql: q
      };

      this.sub2 = this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
            if ( con == null || con == undefined ){
              resolve("");
            }
            if ( con['SQL'] == null || con['SQL'] == undefined ){
              resolve("");
            }
            if ( con['SQL'].length == 0 ){
              resolve("");
            }

            let resultSet = con["SQL"][0]['TEXTO'];
            if ( resultSet == null || resultSet == undefined ){ 
              resolve("");
            }else{
              resolve(resultSet);  
            }
            
          });

      });
  }


  executeQuery(item:TabQuerySettings,type, btn:QueryConnSettings = null, icon:string = null){
    
    if ( !ObjectUtil.isNotEmpty(item.query)){
      return;
    }
    this.showLoadingOverlay(item);

    if ( icon != null && icon != ""){
      item.icon = icon;
    }
    
    item.type = type;
    if ( btn != null ){
      item.btnName = btn.NAME;
    }else{
      item.btnName = null;
    }

    this.queryExecuted = true;

    if ( type == 'sqlserver' || type == 'mongodb'){

      this.queryServices.findNative(item.query,this.testMode,this.maxRows,type).then((data:any[])=>{
          item.rows = data;
          this.mountColumns(data,item);
          item.gridAPI.applyTransaction({ add: data });
          item.icon = icon;
          this.hideLoadingOverlay(item);
          return data;

      }).catch(e=>{
          this.hideLoadingOverlay(item);
          throw e;
      });
    }else{

      let ob = {
          expressao: btn.FORMULA,
          'novo':true,
          'values':[
              {
                  'key':'@QUERY',
                  'value':item.query
              },
              {
                  'key':'@CODECOMPANY',
                  'value':btn.CODECOMPANY
              },
              {
                  'key':'@CODECOMPANYRUNTIME',
                  'value': btn.CODECOMPANY  
              },
              {
                  'key':'@USERID',
                  'value': this.us.user.iduser
              }              
          ]
      }

      let listaCompanies = this.us.user.companylist.find(d=>d.codecompany == btn.CODECOMPANY);

      if ( listaCompanies != null ){
        ob.values.push({
          'key':'@CODECONTRACT',
          'value': listaCompanies.codecontract
          },
          {
            'key':'@CODECONTRACTRUNTIME',
            'value': listaCompanies.codecontract
          });
      };

      this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe({
        next:(data)=>{

          let resultado = data['resultado'];
          
          let SQL:Object[] = null;
          
          try{
              SQL = JSON.parse(resultado)['SQL'];	
          }catch(e){
              SQL = JSON.parse(resultado);
          }
          
          if ( SQL != null ){
            item.rows = SQL;
            this.mountColumns(SQL,item);
            item.gridAPI.applyTransaction({ add: SQL });
            this.hideLoadingOverlay(item);
            this.saveUserConfig();
          }
        },
        error:(error)=>{
          this.hideLoadingOverlay(item);
          throw error;
        }
      }
      );
    }
      
  }


  executeQueryTestMode(){
    
    if ( !ObjectUtil.isNotEmpty(this.query)){
      return;
    }
    this.showLoadingOverlayTestMode();

    this.queryExecuted = true;
    let type = 'sqlserver';

    this.queryServices.findNative(this.query,false,this.maxRows,type).then((data:any[])=>{
        this.rowsTestMode = data;
        this.mountColumnsTestMode(data);
        this.gridAPI.applyTransaction({ add: data });
        this.hideLoadingOverlayTestMode();
        this.saveUserConfig();
        return data;

    }).catch(e=>{
        this.hideLoadingOverlayTestMode();
        throw e;
    });
    
      
  }
  
  findObjectWithMostKeys(arr: Object[]): number | null {
    if (arr.length === 0) return 0;
  
    let objectWithMostKeys = 0;
    let maxKeys = Object.keys(arr[0]).length;
    
    let i = 0;
    for (const obj of arr) {
      const keyCount = Object.keys(obj).length;
      if (keyCount > maxKeys) {
        maxKeys = keyCount;
        objectWithMostKeys = i;
      }
      i++;
    }
  
    return objectWithMostKeys;
  }

  mountColumns(data:any[],item:TabQuerySettings){
      item.displayedColumns = [];
      if (data.length > 0 ){
        let index = this.findObjectWithMostKeys(data);
        Object.keys(data[index]).forEach(key=>{
            let col:ColDef = {
                headerName: key,
                field: key,
                sortable:true,
                filter: true,
                resizable: true,
                colId: key
            }
            item.displayedColumns.push(col);
        });
      }
  }

  mountColumnsTestMode(data:any[]){
      this.displayedColumnsTestMode = [];
      if (data.length > 0 ){
        let index = this.findObjectWithMostKeys(data);
        Object.keys(data[index]).forEach(key=>{
            let col:ColDef = {
                headerName: key,
                field: key,
                sortable:true,
                filter: true,
                resizable: true,
                colId: key
            }
            this.displayedColumnsTestMode.push(col);
        });
      }
  }


  
  applyGridColors(){
    // if ( this.gridColor != null ){
    //   let fn = new Function("params",this.gridColor) as (params:RowClassParams)=>{};
    //   if ( fn!= null ){
    //     try{
    //       this.gridApi.setGetRowStyle(fn);
    //     }catch(Exception){
    
    //     }
        
    //   }
      
    // }
  }


  onGridReady(event: GridReadyEvent, item:TabQuerySettings) {
    
    item.gridAPI = event.api;
    this.hideLoadingOverlay(item);
    //this.applyGridColors();
    
  }

  onGridReadyTestMode(event: GridReadyEvent) {
    
    this.gridAPI = event.api;
    this.hideLoadingOverlayTestMode();
    //this.applyGridColors();
    
  }
  
  emitQueryEvent(evento){
    this.queryChange.emit(evento);
  }

  okFunction(data){
    this.dialogRef.close(data);
  }

  
  showLoadingOverlay(item:TabQuerySettings) {
    item.gridAPI.showLoadingOverlay();
  }

  hideLoadingOverlay(item:TabQuerySettings) {
    item.gridAPI.hideOverlay();
  }

  showLoadingOverlayTestMode() {
    this.gridAPI.showLoadingOverlay();
  }

  hideLoadingOverlayTestMode() {
    this.gridAPI.hideOverlay();
  }

  getDataForExport() {
    return this.getCurrentRow();
  }

  exportToExcel() {
    // Assuming your datagrid data is stored in a variable called `data`
    const data = this.getDataForExport(); // Replace with your actual data retrieval method

    // Create a worksheet from the data
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Create a workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'DataGrid');

    // Generate Excel file and trigger download
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'queryExecutor.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  closeTab(value:number){
    
    this.dialogServices.title = "Exclusão de Aba";
    this.dialogServices.openNewDialog(
      "Deseja realmente excluir esta aba?",
      (data) => {
            let index = this.tabs.findIndex(d=>d.index == value);

            this.tabs.splice(index,1);
            // bug antigo: decrementava o índice mesmo depois de setá-lo para -1,
            // podendo ficar em -2 ou apontar para a aba errada
            if ( this.tabs.length == 0 ){
              this.selectedTabIndex = -1;
            }else if ( this.selectedTabIndex >= this.tabs.length ){
              this.selectedTabIndex = this.tabs.length - 1;
            }
            this.saveUserConfig();
      });
  }

  selectedData(event:RowSelectedEvent){
        if ( this.getCurrentItem().selectedRows == null ){
          this.getCurrentItem().selectedRows = [];
        }
        
        let index = this.getCurrentItem().selectedRows.findIndex(d=>d.index == event.rowIndex);
        if ( index > -1 ){
          this.getCurrentItem().selectedRows.splice(index,1);
        }else{
          this.getCurrentItem().selectedRows.push({index:event.rowIndex, data:event.data});
        }
  
        if ( this.getCurrentItem().selectedRows.length == 0){
          this.getCurrentItem().dataGridFocus = false;
        }else{
          this.getCurrentItem().dataGridFocus = true;
        }
  }

  disableTab(){
      if (this.getCurrentItem()!= null){
        if ( this.getCurrentItem().type=="sqlserver_desc_object" ){ 
          return true;
        }else{
          return false;      
        }
      }
      
  }

  addNewTab(evento){
      
      let id:number = this.tabs == null || this.tabs.length == 0  ? 1 : Math.max(...this.tabs.map(d=>d.index))+1;
      
      let newTab:TabQuerySettings = {
          index:id,
          name:"Query "+id.toString(),
          query:"",
          leftDivVer:50,
          rightDivVer:50,
          displayedColumns:[],
          rows:[],
          gridAPI:null,
          icon:'temapi',
          type:null,
          btnName:null,
          columnSelected:null,
          dataGridFocus:false,
          rowIndex:-1,
          selectedRows:[]
      }
      this.tabs.push(newTab);
      setTimeout(() => {
        this.selectedTabIndex = this.tabs.length - 1;
      });

      this.saveUserConfig();
  }
  
  
}
